import { get, post, put, del } from './apiClient';

export interface DeploymentEnvironment {
    name: string;
    keycloak?: { baseUrl?: string; adminUrl?: string; realmSuffix?: string };
    vault?: { url?: string; secretStoreName?: string };
    messageBus?: { connectionString?: string; daprComponent?: string };
    redis?: { host?: string; passwordSecretKey?: string };
    clusters?: string[];
    notes?: string;
}

export interface Deployment {
    _id?: string;
    name: string;
    description?: string;
    type: 'azure' | 'kubernetes' | 'docker' | 'hybrid';
    vault?: { url?: string; secretStoreName?: string; tenantId?: string };
    acr?: { loginServer?: string; resourceGroup?: string; subscriptionId?: string };
    domainBase?: string;
    environments: DeploymentEnvironment[];
    isDefault?: boolean;
    createdAt?: string;
    updatedAt?: string;
}

export const getAllDeployments  = () => get<{ success: boolean; data: Deployment[] }>('/environments');
export const getDeploymentById  = (id: string) => get<{ success: boolean; data: Deployment }>(`/environments/${id}`);
export const createDeployment   = (data: Partial<Deployment>) => post<{ success: boolean; data: Deployment }>('/environments', data);
export const updateDeployment   = (id: string, data: Partial<Deployment>) => put<{ success: boolean; data: Deployment }>(`/environments/${id}`, data);
export const deleteDeployment   = (id: string) => del<{ success: boolean }>(`/environments/${id}`);

export const addEnvironment     = (id: string, env: DeploymentEnvironment) =>
    post<{ success: boolean; data: Deployment }>(`/environments/${id}/environments`, env);
export const updateEnvironment  = (id: string, envName: string, env: Partial<DeploymentEnvironment>) =>
    put<{ success: boolean; data: Deployment }>(`/environments/${id}/environments/${encodeURIComponent(envName)}`, env);
export const deleteEnvironment  = (id: string, envName: string) =>
    del<{ success: boolean; data: Deployment }>(`/environments/${id}/environments/${encodeURIComponent(envName)}`);
